import { useMutation } from '@tanstack/react-query';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useCallback } from 'react';
import { UseMutationOptions } from '@tanstack/react-query/src/types';
import {
  LoginFormData,
  PostLoginRes,
} from '../../apis/kstadiumAPI/logIn/types';
import KStadiumAPI from '../../apis/kstadiumAPI';

type Options = Omit<
  UseMutationOptions<PostLoginRes, Error, LoginFormData>,
  'mutationFn'
>;
const useLogIn = (options: Options) => {
  const {
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm<LoginFormData>({
    mode: `onChange`,
  });
  const { mutateAsync: postLogIn, error } = useMutation<
    PostLoginRes,
    Error,
    LoginFormData
  >(KStadiumAPI.logIn, options);

  const onSubmit: SubmitHandler<LoginFormData> = useCallback(
    async (data) => {
      await postLogIn(data);
    },
    [postLogIn],
  );

  return {
    register,
    onSubmit: handleSubmit(onSubmit),
    isValid,
    fail: !!error,
  };
};

export default useLogIn;
